<div class="auditHolder">
    <div class="header">
        <img src="../../../assets/images/logo/flowtrics_logo.png" alt="">
    </div>
    <div class="trailHolder">
        <table cellspacing="0" cellspadding="0" >
            <tr>
                <td><b>Subject</b></td>
                <td>Documents needs to be signed</td>
            </tr>
            <tr>
                <td><b>Document Name</b></td>
                <td>Registration.pdf, Rent Agreement.pdf</td>
            </tr>
            <tr>
                <td><b>flowtrics Id</b></td>
                <td>44s4s5649s4423s16s9as7f4f797as9f7</td>
            </tr>
            <tr>
                <td><b>Status</b></td>
                <td>
                    <span class="complete" >Compeleted</span>
                    <span class="decline" >Decline</span>
                    <span class="withdraw" >Withdraw</span>
                </td>
            </tr>
            <tr>
                <td><b>Participants</b></td>
                <td>3</td>
            </tr>
            <tr>
                <td><b>Document</b></td>
                <td>3</td>
            </tr>
            <tr>
                <td><b>Pages</b></td>
                <td>30</td>
            </tr>

            <tr>
                <td colspan="2">
                    <h3>Document History</h3>
                </td>
            </tr>
            <tr class="documentHistory">
                <td>
                    <div class="state">
                        <div class="nameIcon">
                            <mat-icon>mark_email_read</mat-icon> Sent
                        </div>
                        <div class="time">
                            <p><b>03/11/2021</b></p>
                            <p>07:32:47 UTC</p>
                        </div>
                    </div>
                </td>
                <td>
                    <p>Sent for signature to surender (surender@mailinator.com) and sumit (sumit@mailinator.com)</p>
                    <p>IP: 203.190.154.146</p>
                </td>
            </tr>

            <tr class="sepSection">
                <td>
                    <div class="state">
                        <div class="nameIcon">
                            <mat-icon>remove_red_eye</mat-icon> Viewed
                        </div>
                        <div class="time">
                            <p><b>03/11/2021</b></p>
                            <p>07:33:47 UTC</p>
                        </div>
                    </div>
                </td>
                <td>
                    <p>Viewed by surender (surender@mailinator.com)</p>
                    <p>IP: 203.190.154.146</p>
                </td>
            </tr>

            <tr class="sepSection">
                <td>
                    <div class="state">
                        <div class="nameIcon">
                            <mat-icon>remove_red_eye</mat-icon> Viewed
                        </div>
                        <div class="time">
                            <p><b>03/11/2021</b></p>
                            <p>07:35:47 UTC</p>
                        </div>
                    </div>
                </td>
                <td>
                    <p>Viewed by sumit (sumit@mailinator.com)</p>
                    <p>IP: 203.190.154.146</p>
                </td>
            </tr>

            <tr class="sepSection">
                <td>
                    <div class="state">
                        <div class="nameIcon">
                            <mat-icon>create</mat-icon> Signed
                        </div>
                        <div class="time">
                            <p><b>03/11/2021</b></p>
                            <p>07:40:47 UTC</p>
                        </div>
                    </div>
                </td>
                <td>
                    <p>Signed by surender (surender@mailinator.com)</p>
                    <p>IP: 190.190.154.146</p>
                </td>
            </tr>

            <tr class="sepSection">
                <td>
                    <div class="state">
                        <div class="nameIcon">
                            <mat-icon>check_circle_outline</mat-icon> Completed
                        </div>
                        <div class="time">
                            <p><b>03/11/2021</b></p>
                            <p>08:00:47 UTC</p>
                        </div>
                    </div>
                </td>
                <td>
                    <p>This document has been completed</p>                    
                </td>
            </tr>

        </table>
    </div>
</div>







